<template>
    <div class="feedback-carregando" v-if="$store.state.carregandoInline">
        <div class="esferas" style="--ordem-esfera: 0"></div>
        <div class="esferas" style="--ordem-esfera: 1.5"></div>
        <div class="esferas" style="--ordem-esfera: 3"></div>
    </div>
</template>
